import { PLAN_ORDER } from '../../lib/plan';
import type { ClientesSearch } from '../routes/Clientes';
import type { FinanzasSearch, FinanzasTab } from '../routes/Finanzas';

/**
 * What the address of Clientes and Finanzas may carry. Anything the page does not
 * understand is dropped, so an old link or a typo opens the plain page instead of
 * breaking it.
 */

const MAX_QUERY = 80;
const ESTADOS: readonly NonNullable<ClientesSearch['estado']>[] = ['activos', 'prueba', 'inactivos', 'todos'];
const PAGOS: readonly NonNullable<ClientesSearch['pago']>[] = ['al_dia', 'atrasado'];
const TABS: readonly FinanzasTab[] = ['movimientos', 'suscripciones', 'proximos'];

function oneOf<T extends string>(value: unknown, choices: readonly T[]): T | undefined {
  return typeof value === 'string' ? choices.find((choice) => choice === value) : undefined;
}

export function parseClientesSearch(search: Record<string, unknown>): ClientesSearch {
  const q = typeof search.q === 'string' ? search.q.slice(0, MAX_QUERY) : '';
  const estado = oneOf(search.estado, ESTADOS);
  const pago = oneOf(search.pago, PAGOS);
  const plan = oneOf(search.plan, PLAN_ORDER);
  return {
    ...(q ? { q } : {}),
    ...(estado ? { estado } : {}),
    ...(pago ? { pago } : {}),
    ...(plan ? { plan } : {}),
  };
}

export function parseFinanzasSearch(search: Record<string, unknown>): FinanzasSearch {
  const tab = oneOf(search.tab, TABS);
  return tab ? { tab } : {};
}
